export function lowerCaseStringCompare(a, b) {
	return a?.toLowerCase() === b?.toLowerCase();
}
